export enum SandboxDragKind {
    Move = 'move',
    ResizeBottom = 'resize-bottom',
    ResizeCorner = 'resize-corner',
    ResizeRight = 'resize-right'
}
